import { Dialog } from 'radix-ui'
import type { ReactNode } from 'react'
import { Button } from './button.js'

/**
 * Подтверждение необратимого действия.
 *
 * Построено на Radix, а не на своём диалоге, по одной причине: правильный
 * модальный диалог — это ловушка фокуса, возврат фокуса на вызвавшую кнопку,
 * закрытие по Esc, блокировка прокрутки под ним и корректные aria-связи.
 * Всё это пишется самому за день и потом годами ломается на краях. Radix
 * даёт поведение без внешнего вида, поэтому оформление остаётся нашим —
 * ровно та сделка, которая была записана в решениях по стеку.
 */
export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = 'Подтвердить',
  cancelLabel = 'Отмена',
  danger = false,
  loading = false,
  onConfirm,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description?: ReactNode
  confirmLabel?: string
  cancelLabel?: string
  danger?: boolean
  loading?: boolean
  onConfirm: () => void
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-black/40" />
        <Dialog.Content
          className="fixed top-1/2 left-1/2 z-50 w-[min(28rem,calc(100vw-2rem))] -translate-x-1/2 -translate-y-1/2 rounded-lg border border-line bg-raised p-5 shadow-xl"
          aria-describedby={description ? undefined : ''}
        >
          <Dialog.Title className="text-base font-semibold text-ink">{title}</Dialog.Title>

          {description && (
            <Dialog.Description className="mt-2 text-sm text-muted">
              {description}
            </Dialog.Description>
          )}

          <div className="mt-5 flex justify-end gap-2">
            <Dialog.Close asChild>
              <Button variant="ghost" disabled={loading}>
                {cancelLabel}
              </Button>
            </Dialog.Close>
            <Button variant={danger ? 'danger' : 'primary'} loading={loading} onClick={onConfirm}>
              {confirmLabel}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
